import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { createShellComposerBridge, } from '../utilities/shellComposerBridge';
/**
 * Per-bundle fallback bridge. When the shell wraps a tree in
 * `ShellComposerBridgeProvider` with its injected bridge, cross-app messaging
 * works. Without a provider (a standalone app, or a unit test that doesn't wrap
 * one), hooks fall back to this instance so they never crash — emits/subscribes
 * then connect *within this bundle only*, the same scope a lone app had before.
 * Created lazily so importing this module has no side effects.
 */
var fallbackBridge = null;
var getFallbackBridge = function () {
    if (!fallbackBridge) {
        fallbackBridge = createShellComposerBridge();
    }
    return fallbackBridge;
};
var ShellComposerBridgeContext = createContext(null);
/**
 * Provides the shell's event-composer bridge to a tree. The shell wraps its own
 * subtree (which hosts the composer) with its bridge instance, and each MFE
 * wraps its root with the same instance received via single-spa `customProps`.
 */
export var ShellComposerBridgeProvider = function (_a) {
    var composerBridge = _a.composerBridge, children = _a.children;
    return (_jsx(ShellComposerBridgeContext.Provider, { value: composerBridge, children: children }));
};
/**
 * Returns the shell-provided event-composer bridge, or a per-bundle fallback
 * when no provider is present. Channel hooks (`useEventDraftPatch`,
 * `useSiderArbitration`, the lifecycle hooks, …) call this internally.
 */
export var useShellComposerBridge = function () { var _a; return (_a = useContext(ShellComposerBridgeContext)) !== null && _a !== void 0 ? _a : getFallbackBridge(); };
